import React, { useState, useEffect } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux'; 
import apiServices from '../../../actions/services';

const UsuariosList = () =>{
  const { user } = useSelector(state => state.auth);  
  const [respuesta, setRespuesta] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [usuarioEdit, setUsuarioEdit] = useState({
      Id_Usuario: '',
      Usuario: '',
      Nombre: '',
      Apellido: '',
      CodEmpAlt: ''
  });

 useEffect(() => {
  obtenerUsuarios();
}, []);


    const obtenerUsuarios = async () => {
        // const datos = {
        //     Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
        //     Ambiente: "DESA",
        //     Dispositivo: {
        //       Marca: "SAMSUNG",
        //       Modelo: "S22002B",
        //       Version: "Android 18.125",
        //       McAdress: null,
        //       PowerStatus: "84%",
        //       WifiStatus: "Conected to iphone de Mauricio",
        //       GPSStatus: "ON",
        //       GPS: "321|-485|321",
        //     },
        //     Usr: {
        //       Codigo: "",
        //       UserNickName: "pierril",
        //     },
        //     DatosMetodo: {
        //       NombreMetodo: "ObtenerListaUsuarios",
        //       Datos_Recibidos: ,
        //     },
        //   };
          //console.log(datos)
          //const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`;
          try {
            const dat ={ CodUsu: user.id_usuario };
            const response = await apiServices.get("ObtenerListaUsuarios",dat); // fetch(fetchDataUrl);
        
            // if (!response.ok) {
            //   throw new Error(`Error en la solicitud: ${response.status} ${response.statusText}`);
            // }
        
            const data = response;
            console.log('Respuesta de la API (GET):', data);
        
            // Parsear datos_Generados y acceder a PAGO_CHEQUE
            if (data.datos_Generados) {
              const datosGenerados = JSON.parse(data.datos_Generados); // Convertir de string a objeto
              if (datosGenerados) { 
                console.log(datosGenerados);
                setRespuesta(datosGenerados); // Asignar PAGO_CHEQUE al estado
                console.log(respuesta);
              } else {
                console.error('USUARIOS no encontrado o inválido:', datosGenerados);
                //setError('No se encontraron datos generados en la respuesta.');
              }
            } else {
              console.error('datos_Generados no encontrado o inválido:', data);
              //setError('No se encontraron datos generados en la respuesta.');
            }
          } catch (error) {
            console.error('Error al obtener los datos:', error);
            //setError(error.message || 'Error al obtener los datos de la API.');
          } 
    };
    const handleOpenModal = (usuario) => {
      setUsuarioEdit({
          Id_Usuario: usuario.Id_Usuario,
          Usuario: usuario.Usuario,
          Nombre: usuario.Nombre,
          Apellido: usuario.Apellido,
          CodEmpAlt: usuario.CodEmpAlt
      });
      setShowModal(true);
  };

  // Función para manejar cambios en los inputs del modal
  const handleInputChange = (e) => {
      const { name, value } = e.target;
      setUsuarioEdit(prev => ({
          ...prev,
          [name]: value
      }));
  };

  // Función para guardar los cambios del usuario
  const ModificarUsuario = () => {
      console.log('Usuario modificado:', usuarioEdit);
      // Aquí iría la lógica para actualizar el usuario en el servidor
      setShowModal(false);
  };

return(
    <div>
        <h1>Usuarios</h1>
      <div>
        <br></br>
        {respuesta && respuesta.USUARIOS ? (
    <table className="table table-striped table-bordered">
      <thead>
        <tr>
          {/* <th>ID Usuario</th> */}
          <th>Usuario</th>
          <th>Nombre</th>
          <th>Apellido</th>
          <th>Código Emp. Alt.</th>
        </tr>
      </thead>
      <tbody>
        {respuesta.USUARIOS.map((usuario) => (
          <tr key={usuario.Id_Usuario}>
            {/* <td>{usuario.Id_Usuario}</td> */}
            <td>{usuario.Usuario}</td>
            <td>{usuario.Nombre}</td>
            <td>{usuario.Apellido}</td>
            <td>{usuario.CodEmpAlt}</td>
            <td><button  className="btn btn-warning me-2"   onClick={() => handleOpenModal(usuario)}> <i className="fa fa-edit fa-small"></i>  </button> </td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <p>No hay datos para mostrar. Haz clic en "Buscar" para cargar los usuarios.</p>
  )}
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Editar Usuario</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>ID Usuario</Form.Label>
                            <Form.Control 
                                type="text" 
                                name="Id_Usuario"
                                value={usuarioEdit.Id_Usuario} 
                                disabled
                            />
                        </Form.Group>
                        
                        <Form.Group className="mb-3">
                            <Form.Label>Usuario</Form.Label>
                            <Form.Control 
                                type="text" 
                                name="Usuario"
                                value={usuarioEdit.Usuario} 
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        
                        <Form.Group className="mb-3">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control 
                                type="text" 
                                name="Nombre"
                                value={usuarioEdit.Nombre} 
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        
                        <Form.Group className="mb-3">
                            <Form.Label>Apellido</Form.Label>
                            <Form.Control 
                                type="text" 
                                name="Apellido"
                                value={usuarioEdit.Apellido} 
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        
                        <Form.Group className="mb-3">
                            <Form.Label>Código Emp. Alt.</Form.Label>
                            <Form.Control 
                                type="text" 
                                name="CodEmpAlt"
                                value={usuarioEdit.CodEmpAlt} 
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={ModificarUsuario}>
                        Guardar Cambios
                    </Button>
                </Modal.Footer>
            </Modal>
   </div>
);
}
export default UsuariosList;